import React, { useState } from "react";
import "../../Styles/Mp4Form.css";

function AdminMp4Form() {
  const [videoSource, setVideoSource] = useState("youtube"); // "youtube" | "upload"
  const [preview, setPreview] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      setFileName(file.name);
    }
  };

  const handleSourceChange = (source) => {
    setVideoSource(source);
    setPreview(null);
    setFileName("");
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Add MP4 Video</h2>
        <button className="back-btn-mp4" onClick={() => window.history.back()}>
          Back
        </button>
      </div>

      <form className="mp4-form">
        <div className="form-group">
          <label>Video Title</label>
          <input type="text" placeholder="Enter Video Title" required />
        </div>

        {/* ---------- SOURCE TOGGLE ---------- */}
        <div className="form-group">
          <label>Video Source</label>
          <div className="mp4-source-toggle">
            <button
              type="button"
              className={`mp4-toggle-btn ${
                videoSource === "youtube" ? "mp4-toggle-active" : ""
              }`}
              onClick={() => handleSourceChange("youtube")}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="5" width="20" height="14" rx="4" stroke="currentColor" strokeWidth="1.8" />
                <path d="M10 9l6 3-6 3V9z" fill="currentColor" />
              </svg>
              YouTube URL
            </button>

            <button
              type="button"
              className={`mp4-toggle-btn ${
                videoSource === "upload" ? "mp4-toggle-active" : ""
              }`}
              onClick={() => handleSourceChange("upload")}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 3v12m0 0l-4.5-4.5M12 15l4.5-4.5"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
              Upload Video
            </button>
          </div>
        </div>

        {/* ---------- CONDITIONAL FIELD ---------- */}
        {videoSource === "youtube" ? (
          <div className="form-group">
            <label>YouTube Embed URL</label>
            <input
              type="url"
              placeholder="https://www.youtube.com/embed/VIDEO_ID"
              required
            />
          </div>
        ) : (
          <div className="form-group">
            <label>Upload Video File</label>
            <input
              type="file"
              accept=".mp4,video/*"
              onChange={handleFileChange}
              required
            />

            {fileName && (
              <div className="mp4-file-info">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                  <path d="M14 2v6h6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                </svg>
                {fileName}
              </div>
            )}

            {preview && (
              <div className="mp4-preview-box">
                <video src={preview} controls className="mp4-preview-video" />
              </div>
            )}
          </div>
        )}

        <div className="form-group">
          <label>Description</label>
          <textarea rows="4" placeholder="Optional Description"></textarea>
        </div>

        <button className="sub-btn" type="submit">
          Submit MP4 Video
        </button>
      </form>
    </div>
  );
}

export default AdminMp4Form;